<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.88804 5.77285L7.47354 7.69121C7.81098 7.83205 8.18078 7.83691 8.52747 7.69121L13.113 5.77285C14.2963 5.27747 14.2963 3.51937 13.113 3.024L8.52747 1.10563C8.19003 0.964789 7.81561 0.964789 7.47816 1.10563L2.88804 3.024C1.70468 3.51937 1.70468 5.27747 2.88804 5.77285Z"
    />
    <path
      d="M13.4922 7.04159C13.4922 7.04159 13.4691 7.05537 13.4553 7.05996L8.86957 8.87372C8.31022 9.09412 7.69079 9.09412 7.13144 8.87372L2.54574 7.05996C2.54574 7.05996 2.52263 7.04618 2.50876 7.04159C1.72291 7.67985 1.84772 9.01147 2.88782 9.42014L7.47352 11.2339C7.81098 11.3671 8.18079 11.3716 8.52749 11.2339L13.1132 9.42014C14.1533 9.00688 14.2781 7.67526 13.4922 7.04159Z"
    />
    <path
      d="M13.4904 10.3483C13.4904 10.3483 13.4673 10.3632 13.4534 10.3682L8.86843 12.3331C8.30917 12.5718 7.68984 12.5718 7.13058 12.3331L2.54562 10.3682C2.54562 10.3682 2.52251 10.3533 2.50865 10.3483C1.72292 11.0347 1.84771 12.4823 2.88765 12.925L7.4726 14.8899C7.81001 15.0342 8.17976 15.0392 8.5264 14.8899L13.1114 12.925C14.1513 12.4773 14.2807 11.0347 13.4904 10.3483Z"
    />
  </svg>
</template>
